export function Card({ children }) {
  return (
    <div className="border rounded-2xl shadow-lg bg-white w-full max-w-lg">
      {children}
    </div>
  );
}
